var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49_1771)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_49_1771",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8001 0H2.2001C1.31644 0 0.600098 0.716344 0.600098 1.6V10.4C0.600098 11.2837 1.31644 12 2.2001 12H15.8001C16.6838 12 17.4001 11.2837 17.4001 10.4V1.6C17.4001 0.716344 16.6838 0 15.8001 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_49_1771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8001 0H2.2001C1.31644 0 0.600098 0.716344 0.600098 1.6V10.4C0.600098 11.2837 1.31644 12 2.2001 12H15.8001C16.6838 12 17.4001 11.2837 17.4001 10.4V1.6C17.4001 0.716344 16.6838 0 15.8001 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.600098 0H7.8001V5.6H0.600098V0Z",
    fill: "#444379"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3999 0.799999V1.6H2.1999V0.799999H1.3999ZM2.9999 0.799999V1.6H3.7999V0.799999H2.9999ZM4.5999 0.799999V1.6H5.3999V0.799999H4.5999ZM6.1999 0.799999V1.6H6.9999V0.799999H6.1999ZM5.3999 1.6V2.4H6.1999V1.6H5.3999ZM3.7999 1.6V2.4H4.5999V1.6H3.7999ZM2.1999 1.6V2.4H2.9999V1.6H2.1999ZM1.3999 2.4V3.2H2.1999V2.4H1.3999ZM2.9999 2.4V3.2H3.7999V2.4H2.9999ZM4.5999 2.4V3.2H5.3999V2.4H4.5999ZM6.1999 2.4V3.2H6.9999V2.4H6.1999ZM1.3999 4V4.8H2.1999V4H1.3999ZM2.9999 4V4.8H3.7999V4H2.9999ZM4.5999 4V4.8H5.3999V4H4.5999ZM6.1999 4V4.8H6.9999V4H6.1999ZM5.3999 3.2V4H6.1999V3.2H5.3999ZM3.7999 3.2V4H4.5999V3.2H3.7999ZM2.1999 3.2V4H2.9999V3.2H2.1999Z",
    fill: "#A7B6E7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8001 0V0.8H17.4001V0H7.8001ZM7.8001 1.6V2.4H17.4001V1.6H7.8001ZM7.8001 3.2V4H17.4001V3.2H7.8001ZM7.8001 4.8V5.6H17.4001V4.8H7.8001ZM0.600098 6.4V7.2H17.4001V6.4H0.600098ZM0.600098 8V8.8H17.4001V8H0.600098ZM0.600098 9.6V10.4H17.4001V9.6H0.600098ZM0.600098 11.2V12H17.4001V11.2H0.600098Z",
    fill: "#ED4C49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8 0.400002H2.2C1.53726 0.400002 1 0.93726 1 1.6V10.4C1 11.0627 1.53726 11.6 2.2 11.6H15.8C16.4627 11.6 17 11.0627 17 10.4V1.6C17 0.93726 16.4627 0.400002 15.8 0.400002Z",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 0.8
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_1771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.8,
    height: 12,
    fill: "white",
    transform: "translate(0.600098)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/US.69135e36f01f102e52d2b8e7fbc8890c.svg";
export { ForwardRef as ReactComponent };